import {useEffect} from "react";
import {NavLink, Outlet, useNavigate} from "react-router-dom";
import {isAdmin} from "../../utils/auth";
import {ROUTES} from "../../utils/constants";
import localStyles from "./styles.module.scss";

const adminNavItems = [
    {path: "/admin/tasks", label: "Tasks"},
    {path: "/admin/users", label: "Users"},
    {path: "/admin/links", label: "Links"},
    {path: "/admin/files", label: "Files"},
    {path: "/admin/pre-orders", label: "Pre-Orders"},
    {path: "/admin/photofixation", label: "Photofixation"},
];

const Admin = () => {
    const navigate = useNavigate();

    useEffect(() => {
        if (!isAdmin()) {
            navigate("/" + ROUTES.LINKS);
        }
    }, []);

    return (
        <div className={localStyles.adminContainer}>
            <nav className={localStyles.sidebar}>
                {adminNavItems.map((item) => (
                    <NavLink
                        key={item.path}
                        to={item.path}
                        className={({isActive}) =>
                            `${localStyles.sidebarLink} ${isActive ? localStyles.active : ""}`
                        }
                    >
                        {item.label}
                    </NavLink>
                ))}
            </nav>
            <div className={localStyles.content}>
                <Outlet/>
            </div>
        </div>
    );
};

export default <Admin/>;
